import { useConfig } from "@/api/hooks/useConfig";

import { UseFormReturn } from "react-hook-form";

import { CustomerWithChain } from "../../types";
import { TenantContactInfoFormSection } from "./TenantContactInfoFormSection";
import { TenantDetailsFormSection } from "./TenantDetailsFormSection";

export const CreateSingleTenant = ({
  formHandler,
}: {
  formHandler: UseFormReturn<CustomerWithChain>;
}) => {
  const { isRealEstate } = useConfig();
  return (
    <form className="flex flex-col gap-4 md:flex-row 2xl:justify-between">
      <TenantDetailsFormSection formHandler={formHandler} />
      {isRealEstate && (
        <div>
          <TenantContactInfoFormSection formHandler={formHandler} />
        </div>
      )}
    </form>
  );
};
